/**
 * Paylaşılan disclosure davranışı — dış tıklama / Esc / başkası açılınca kapat.
 *
 * İki tüketici: eyebrow'daki dil-para seçici ve koleksiyon sıralama seçici
 * (snippets/aycan-sort-disclosure.liquid). İkisi de <details>; davranış birebir
 * aynı olduğu için ikinci bir dosya AÇILMADI — yeni bir disclosure eklenirse
 * seçiciye eklenir, kodu tekrarlanmaz.
 */
(() => {
  const SEL = '[data-aycan-locale-combo], [data-aycan-sortsel]';
  const OPEN = '[data-aycan-locale-combo][open], [data-aycan-sortsel][open]';
  const closeAll = (except) => {
    document.querySelectorAll(OPEN).forEach((combo) => {
      if (combo !== except) combo.open = false;
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll(SEL).forEach((combo) => {
      if (combo.dataset.aycanLocaleComboInit === '1') return;
      combo.dataset.aycanLocaleComboInit = '1';

      combo.addEventListener('toggle', () => {
        if (combo.open) closeAll(combo);
      });
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll(OPEN).forEach((combo) => {
      if (!combo.contains(event.target)) combo.open = false;
    });
  });

  /* Seçenek seçilince panel kapanır. facets.js aynı `change` olayında formu
     serileştirip sıralamayı uyguluyor; burada yalnızca görsel durum toparlanıyor. */
  document.addEventListener('change', (event) => {
    const panel = event.target.closest('[data-aycan-sortsel]');
    if (panel) panel.open = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.code !== 'Escape') return;
    closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
